import {get} from "helpers/api"
import {LOADING_TOPICS, STORE_TOPICS} from "./types"

export function getTopics() {
	return dispatch => {
		dispatch(loadingTopics(true))
		get("coaching-topics")
			.then(topics => {
				dispatch(loadingTopics(false))
				dispatch(storeTopics(topics))
			})
			.catch(err => {
				console.log(err)
				dispatch(loadingTopics(false))
			})
	}
}

function loadingTopics(status) {
	return {
		type: LOADING_TOPICS,
		payload: status
	}
}

function storeTopics(topics) {
	return {
		type: STORE_TOPICS,
		payload: topics
	}
}
